import { render } from "./EdmChangeTemplateDialog.vue?vue&type=template&id=e753388e"
import script from "./EdmChangeTemplateDialog.vue?vue&type=script&lang=js"
export * from "./EdmChangeTemplateDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__